import React from 'react';
import { T } from '../../../../../../common/locale/translate';
import FacilitiesOffers from './facilities';

export default class OfferDescription extends React.Component {
  render() {
    const { special_offer } = this.props;

    return (
      <figcaption className="offer-description">
        <span className="category">
          {special_offer.subject.country_name &&
            `${special_offer.subject.country_name}, `}
          {special_offer.subject.region_name}
        </span>
        <div className="wrapper-title-stars">
          <h4 className="title">{special_offer.subject.name}</h4>
          {special_offer.subject.rating && (
            <span className={`stars stars-${special_offer.subject.rating}`} />
          )}
        </div>
        <FacilitiesOffers facilities={special_offer.subject.facilities} />
        <p className="price">
          {T('price_from')}
          <em>
            {' '}
            {parseInt(special_offer.price_pln)} {T('currency_pln')}{' '}
          </em>
          {T('per_person')}
        </p>
      </figcaption>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/pages/home/components/offers_section/offer_description.jsx